import { useCallback } from 'react';
import { FilterConfig } from '@aidkitorg/types/lib/admin-panel/filters';
import { useFilter } from '../contexts/FilterContext';

/**
 * Hook that provides pre-configured props for FilterPanel component
 * that automatically integrates with FilterContext
 */
export const useFilterPanel = (instanceId: string) => {
  const {
    filterConfig,
    setFilterConfig,
    availableFields,
    filterRef
  } = useFilter();

  const handleFilterChange = useCallback((newConfig: FilterConfig) => {
    setFilterConfig(newConfig);
  }, [setFilterConfig]);

  return {
    // FilterPanel props
    filterPanelProps: {
      value: filterConfig,
      onChange: handleFilterChange,
      availableFields,
      instanceId,
      ref: filterRef
    },
    // Direct access to context values
    filterConfig,
    availableFields,
    filterRef
  };
};
